<template>
    <a :href="route.path" class="primary-button" :class="{ 'disabled': disabled }" @click="clicked" >
        <span :class="{ hidden: loading }"><slot></slot></span>
        <loading v-if="loading" :mini="true" :alt="true" ></loading>
    </a>
</template>


<script>
import Loading from './Loading.vue';

export default {
    name: 'Primary-Button',
    components: { Loading },
    props: {
        link: {
            default: () => ({ path: '#' })
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            default: false
        }
    },
    computed: {
        route: function() {
            return this.$router.match(this.link, this.$route)
        }
    },
    methods: {
        clicked: function(e) {
            if ( this.disabled || this.loading ) {
                e.preventDefault()
                e.stopPropagation()
            } else {
                // captures link, such that it does not change during event
                const link = this.link
                const next = () => this.$router.push( link )

                // allow parent to call next() async, must preventDefault on e
                // else next() is called here
                this.$emit('clicked', e, next)
                if ( !e.defaultPrevented ) {
                    e.preventDefault()
                    next()
                }
            }
        }
    }

}
</script>


<style lang="scss">

</style>



// WEBPACK FOOTER //
// PrimaryButton.vue?d4446bc6